<template>
  <div>
    <footer
      class="border-t xl:hidden"
      :class="[
        mode === 'dark'
          ? 'border-dark-border bg-dark-sidebar'
          : 'border-border-100 bg-white-100',
      ]"
    >
      <div class="app-container">
        <div class="py-10">
          <div class="flex items-start justify-between">
            <div class="mr-14">
              <RouterLink to="/" class="flex">
                <img
                  src="/ITAD_Logo_sm.png"
                  alt="ASDI NATD"
                  loading="lazy"
                  width
                  height
                />
              </RouterLink>
            </div>
            <div class="flex gap-20 lg:gap-10">
              <div>
                <h3 class="mb-3 text-[14px] font-medium leading-none">
                  Contact us
                </h3>
                <ul class="grid gap-2">
                  <li class="leading-none">
                    <a
                      href="https://www.ascdi.com/contact/"
                      target="_blank"
                      class="text-[12px] font-medium leading-none underline hover:text-primary-100"
                      :class="[
                        mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                      ]"
                      >email</a
                    >
                  </li>
                  <li class="leading-none">
                    <a
                      href="tel:1-561-266-9016" class="text-[12.5px] font-medium leading-none" :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60',]"
                      >USA: 1-561-266-9016</a>
                  </li>
                  <li class="leading-none">
                    <a
                      href="tel:1-561-266-9016" class="text-[12.5px] font-medium leading-none" :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60',]"
                      >The Netherlands: +31-20-808-6384</a>
                  </li>
                  <li class="leading-none">
                    <a
                      href="tel:1-561-266-9016" class="text-[12.5px] font-medium leading-none" :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60',]"
                      >Poland: +48-83-888-2258</a>
                  </li>
                </ul>
              </div>
              <div>
                <h3 class="mb-3 text-[14px] font-medium leading-none">
                  Address
                </h3>
                <p
                  class="text-[12.5px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                  ]"
                >
                  131 NW First Avenue, <br />
                  Delray Beach, FL 33444
                </p>
              </div>
            </div>
            <div class="flex-1">
              <div class="flex items-start justify-end gap-[56px] xl:ml-10">
                <ul class="flex flex-wrap items-center justify-start gap-3">
                  <li class="leading-none">
                    <a
                      href="http://www.ascdi.com/contact/"
                      target="_blank"
                      class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                      >Contact</a
                    >
                  </li>
                  <li class="leading-none">
                    <a
                      href="http://www.ascdi.com/press/"
                      target="_blank"
                      class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                      >Press</a
                    >
                  </li>
                  <li class="leading-none">
                    <a
                      href="http://www.ascdi.com/advertise/"
                      target="_blank"
                      class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                      >Advertise</a
                    >
                  </li>
                  <li class="leading-none">
                    <a
                      href="http://www.ascdi.com/ascdiblog/"
                      target="_blank"
                      class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                      >Blog</a
                    >
                  </li>
                  <li class="leading-none">
                    <a
                      href="http://www.ascdi.com/faq/"
                      target="_blank"
                      class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                      >FAQ</a
                    >
                  </li>
                  <li class="leading-none">
                    <a
                      href="http://www.ascdi.com/site-map/"
                      target="_blank"
                      class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                      >Site Map</a
                    >
                  </li>
                  <li class="leading-none">
                    <a
                      href="http://www.ascdi.com/privacy/"
                      target="_blank"
                      class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                      >Privacy</a
                    >
                  </li>
                </ul>
                <div>
                  <ul class="mb-[56px] flex items-center justify-end gap-2">
                    <li>
                      <a
                        href="http://www.youtube.com/channel/UCfomSBkQM7JaUASngjdLEXA"
                        target="_blank"
                        class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150 hover:!border-[#FF0034] hover:bg-[#FF0034] hover:text-white-100"
                        :class="[
                          mode === 'dark'
                            ? 'border-dark-border'
                            : 'border-border-10',
                        ]"
                      >
                        <svg
                          width="19"
                          height="13"
                          viewBox="0 0 19 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.8381 3.48494C18.7214 2.37955 18.4702 1.15758 17.546 0.515411C16.8301 0.0174221 15.8891 -0.000988114 15.0107 3.4451e-05C13.1538 0.00105702 11.2959 0.00310614 9.43902 0.00412871C7.65299 0.00617384 5.86695 0.00720139 4.08092 0.00924653C3.33484 0.0102691 2.60958 -0.0469896 1.91664 0.270006C1.32164 0.542008 0.855858 1.05941 0.575553 1.63512C0.186878 2.43578 0.105604 3.34281 0.0587131 4.22835C-0.0277749 5.84094 -0.0183967 7.45762 0.0847637 9.06918C0.160832 10.2451 0.353603 11.5448 1.27996 12.2943C2.10108 12.958 3.25981 12.9907 4.32475 12.9917C7.70508 12.9948 11.0865 12.9979 14.4678 12.9999C14.9013 13.0009 15.3535 12.9928 15.7954 12.9457C16.6644 12.8537 17.4928 12.6093 18.0513 11.9774C18.6151 11.3403 18.7599 10.4537 18.8454 9.61419C19.0538 7.57724 19.0517 5.52087 18.8381 3.48494ZM7.48418 9.35548V3.64447L12.5234 6.49946L7.48418 9.35548Z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/company/ascdi"
                        target="_blank"
                        class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150 hover:!border-[#0077B5] hover:bg-[#0077B5] hover:text-white-100"
                        :class="[
                          mode === 'dark'
                            ? 'border-dark-border'
                            : 'border-border-10',
                        ]"
                      >
                        <svg
                          width="19"
                          height="20"
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.666217 4.26017C0.221274 3.84145 0 3.32314 0 2.70644C0 2.08975 0.222458 1.54862 0.666217 1.12869C1.11116 0.709963 1.68391 0.5 2.38564 0.5C3.08737 0.5 3.63764 0.709963 4.0814 1.12869C4.52634 1.54742 4.74762 2.07415 4.74762 2.70644C4.74762 3.33874 4.52516 3.84145 4.0814 4.26017C3.63646 4.6789 3.07199 4.88887 2.38564 4.88887C1.69929 4.88887 1.11116 4.6789 0.666217 4.26017ZM4.37369 6.66217V19.5H0.372746V6.66217H4.37369Z"
                            fill="currentColor"
                          />
                          <path
                            d="M17.6924 7.9304C18.5645 8.89024 19 10.2076 19 11.885V19.2733H15.2003V12.4057C15.2003 11.5598 14.9837 10.9023 14.5518 10.4344C14.1198 9.96647 13.5376 9.7313 12.8087 9.7313C12.0797 9.7313 11.4975 9.96527 11.0656 10.4344C10.6337 10.9023 10.4171 11.5598 10.4171 12.4057V19.2733H6.59487V6.62624H10.4171V8.30355C10.8041 7.74445 11.3259 7.30292 11.9815 6.97777C12.6371 6.65263 13.3743 6.49065 14.1944 6.49065C15.6547 6.49065 16.8214 6.97056 17.6924 7.9304Z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://twitter.com/ASCDINATD"
                        target="_blank"
                        class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150"
                        :class="[
                          mode === 'dark'
                            ? 'border-dark-border hover:!border-white-100 hover:bg-white-100 hover:text-[#000]'
                            : 'border-border-10 hover:!border-[#000] hover:bg-[#000] hover:text-white-100',
                        ]"
                      >
                        <svg
                          viewBox="0 0 512 512"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="h-[19px] w-[19px]"
                        >
                          <path
                            d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                          ></path>
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.facebook.com/pages/Ascdi-Natd/246285985410420"
                        target="_blank"
                        class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150 hover:!border-[#4267B2] hover:bg-[#4267B2] hover:text-white-100"
                        :class="[
                          mode === 'dark'
                            ? 'border-dark-border'
                            : 'border-border-10',
                        ]"
                      >
                        <svg
                          width="9"
                          height="18"
                          viewBox="0 0 9 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.0324 4.33062V6.72736H8.99923L8.52944 9.95592H6.0324V17.3944C5.53176 17.4638 5.01954 17.5 4.49961 17.5C3.89946 17.5 3.31011 17.4522 2.73618 17.3597V9.95592H0V6.72736H2.73618V3.79485C2.73618 1.97551 4.21188 0.5 6.03317 0.5V0.501543C6.03857 0.501543 6.0432 0.5 6.0486 0.5H9V3.29222H7.07148C6.49833 3.29222 6.03317 3.75707 6.03317 4.32985L6.0324 4.33062Z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                  <p class="text-right text-[12.5px] font-medium">
                    Copyright © {{ currentYear }} ASCDI
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <footer
      class="hidden border-t px-4 xl:block"
      :class="[
        mode === 'dark'
          ? 'border-dark-border bg-dark-sidebar'
          : 'border-border-100 bg-white-100',
      ]"
    >
      <div class="py-8">
        <div
          class="border-b pb-5"
          :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
        >
          <div class="flex items-start justify-between">
            <div class="flex-1">
              <ul class="flex flex-col gap-3">
                <li class="leading-none">
                  <a
                    href="http://www.ascdi.com/contact/"
                    target="_blank"
                    class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                    >Contact</a
                  >
                </li>
                <li class="leading-none">
                  <a
                    href="http://www.ascdi.com/press/"
                    target="_blank"
                    class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                    >Press</a
                  >
                </li>
                <li class="leading-none">
                  <a
                    href="http://www.ascdi.com/advertise/"
                    target="_blank"
                    class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                    >Advertise</a
                  >
                </li>
                <li class="leading-none">
                  <a
                    href="http://www.ascdi.com/ascdiblog/"
                    target="_blank"
                    class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                    >Blog</a
                  >
                </li>
              </ul>
            </div>
            <div class="flex flex-1 justify-center">
              <ul class="flex flex-col gap-3">
                <li class="leading-none">
                  <a
                    href="http://www.ascdi.com/faq/"
                    target="_blank"
                    class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                    >FAQ</a
                  >
                </li>
                <li class="leading-none">
                  <a
                    href="http://www.ascdi.com/site-map/"
                    target="_blank"
                    class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                    >Site Map</a
                  >
                </li>
                <li class="leading-none">
                  <a
                    href="http://www.ascdi.com/privacy/"
                    target="_blank"
                    class="text-[14px] font-medium capitalize transition-colors duration-200 hover:text-primary-100"
                    >Privacy</a
                  >
                </li>
              </ul>
            </div>
            <div class="flex-1">
              <RouterLink to="/" class="flex justify-end">
                <img
                  src="/ITAD_Logo_sm.png"
                  alt="ASDI NATD"
                  loading="lazy"
                  width
                  height
                />
              </RouterLink>
            </div>
          </div>
        </div>
        <div class="pt-5">
          <div class="mb-3">
            <h3 class="mb-1.5 text-[14px] font-medium leading-none">
              Contact us
            </h3>
            <ul class="flex items-center gap-1.5">
              <li class="leading-none">
                <a
                  href="https://www.ascdi.com/contact/"
                  target="_blank"
                  class="text-[12px] font-medium leading-none underline hover:text-primary-100"
                  :class="[
                    mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                  ]"
                  >email</a
                >
              </li>
              <li
                class="mt-[3px] leading-none"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
              >
                -
              </li>
              <li class="leading-none">
                <a
                  href="tel:1-561-266-9016"
                  class="text-[12.5px] font-medium leading-none"
                  :class="[
                    mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                  ]"
                  >1-561-266-9016</a
                >
              </li>
            </ul>
          </div>
          <div>
            <h3 class="mb-2 text-[14px] font-medium leading-none">Address</h3>
            <p
              class="text-[12.5px] font-medium"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >
              LLC- 131 NW First Avenue, <br />
              Delray Beach, FL 33444
            </p>
          </div>
        </div>
        <div class="pt-5">
          <div class="flex items-center justify-between">
            <ul class="flex items-center gap-2">
              <li>
                <a
                  href="http://www.youtube.com/channel/UCfomSBkQM7JaUASngjdLEXA"
                  target="_blank"
                  class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150 hover:!border-[#FF0034] hover:bg-[#FF0034] hover:text-white-100"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <svg
                    width="19"
                    height="13"
                    viewBox="0 0 19 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.8381 3.48494C18.7214 2.37955 18.4702 1.15758 17.546 0.515411C16.8301 0.0174221 15.8891 -0.000988114 15.0107 3.4451e-05C13.1538 0.00105702 11.2959 0.00310614 9.43902 0.00412871C7.65299 0.00617384 5.86695 0.00720139 4.08092 0.00924653C3.33484 0.0102691 2.60958 -0.0469896 1.91664 0.270006C1.32164 0.542008 0.855858 1.05941 0.575553 1.63512C0.186878 2.43578 0.105604 3.34281 0.0587131 4.22835C-0.0277749 5.84094 -0.0183967 7.45762 0.0847637 9.06918C0.160832 10.2451 0.353603 11.5448 1.27996 12.2943C2.10108 12.958 3.25981 12.9907 4.32475 12.9917C7.70508 12.9948 11.0865 12.9979 14.4678 12.9999C14.9013 13.0009 15.3535 12.9928 15.7954 12.9457C16.6644 12.8537 17.4928 12.6093 18.0513 11.9774C18.6151 11.3403 18.7599 10.4537 18.8454 9.61419C19.0538 7.57724 19.0517 5.52087 18.8381 3.48494ZM7.48418 9.35548V3.64447L12.5234 6.49946L7.48418 9.35548Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/ascdi"
                  target="_blank"
                  class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150 hover:!border-[#0077B5] hover:bg-[#0077B5] hover:text-white-100"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <svg
                    width="19"
                    height="20"
                    viewBox="0 0 19 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.666217 4.26017C0.221274 3.84145 0 3.32314 0 2.70644C0 2.08975 0.222458 1.54862 0.666217 1.12869C1.11116 0.709963 1.68391 0.5 2.38564 0.5C3.08737 0.5 3.63764 0.709963 4.0814 1.12869C4.52634 1.54742 4.74762 2.07415 4.74762 2.70644C4.74762 3.33874 4.52516 3.84145 4.0814 4.26017C3.63646 4.6789 3.07199 4.88887 2.38564 4.88887C1.69929 4.88887 1.11116 4.6789 0.666217 4.26017ZM4.37369 6.66217V19.5H0.372746V6.66217H4.37369Z"
                      fill="currentColor"
                    />
                    <path
                      d="M17.6924 7.9304C18.5645 8.89024 19 10.2076 19 11.885V19.2733H15.2003V12.4057C15.2003 11.5598 14.9837 10.9023 14.5518 10.4344C14.1198 9.96647 13.5376 9.7313 12.8087 9.7313C12.0797 9.7313 11.4975 9.96527 11.0656 10.4344C10.6337 10.9023 10.4171 11.5598 10.4171 12.4057V19.2733H6.59487V6.62624H10.4171V8.30355C10.8041 7.74445 11.3259 7.30292 11.9815 6.97777C12.6371 6.65263 13.3743 6.49065 14.1944 6.49065C15.6547 6.49065 16.8214 6.97056 17.6924 7.9304Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/ASCDINATD"
                  target="_blank"
                  class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150 hover:!border-[#000] hover:bg-[#000] hover:text-white-100"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <svg
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="h-[19px] w-[19px]"
                  >
                    <path
                      d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                    ></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/pages/Ascdi-Natd/246285985410420"
                  target="_blank"
                  class="flex h-[32px] w-[32px] items-center justify-center rounded border transition-colors duration-150 hover:!border-[#4267B2] hover:bg-[#4267B2] hover:text-white-100"
                  :class="[
                    mode === 'dark' ? 'border-dark-border' : 'border-border-10',
                  ]"
                >
                  <svg
                    width="9"
                    height="18"
                    viewBox="0 0 9 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.0324 4.33062V6.72736H8.99923L8.52944 9.95592H6.0324V17.3944C5.53176 17.4638 5.01954 17.5 4.49961 17.5C3.89946 17.5 3.31011 17.4522 2.73618 17.3597V9.95592H0V6.72736H2.73618V3.79485C2.73618 1.97551 4.21188 0.5 6.03317 0.5V0.501543C6.03857 0.501543 6.0432 0.5 6.0486 0.5H9V3.29222H7.07148C6.49833 3.29222 6.03317 3.75707 6.03317 4.32985L6.0324 4.33062Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              </li>
            </ul>
            <p class="text-[12.5px] font-medium">
              Copyright © {{ currentYear }} ASCDI
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    mode: String,
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
